import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseButton, rem, StyleProps, Tooltip, useDisclosure } from '@bonusly/design-system';

import { ConfirmationModal } from '../common/modal';

export interface BonusUnlinkButtonProps extends StyleProps {
	onClickUnlinkBonus: VoidFunction;
	sectionTitle: string;
}

export const BonusUnlinkButton: FC<BonusUnlinkButtonProps> = ({ onClickUnlinkBonus, sectionTitle }) => {
	const confirmUnlinkModal = useDisclosure();
	const { t } = useTranslation('recognition');
	return (
		<>
			<Tooltip label={t('bonus_card.unlink_modal.action')} openDelay={500} placement="top">
				<CloseButton
					aria-label={t('bonus_card.unlink_modal.action')}
					borderRadius="full"
					boxSize={rem(32)}
					color="gray.400"
					onClick={(event) => {
						confirmUnlinkModal.onOpen();
						event.stopPropagation();
					}}
					size="sm"
				/>
			</Tooltip>
			<ConfirmationModal
				size="sm"
				blockScrollOnMount={false}
				confirmColorScheme="danger"
				confirmText={t('bonus_card.unlink_modal.action')}
				description={t('bonus_card.unlink_modal.description', { sectionTitle })}
				header={t('bonus_card.unlink_modal.header')}
				onConfirm={() => {
					confirmUnlinkModal.onClose();
					onClickUnlinkBonus();
				}}
				{...confirmUnlinkModal}
			/>
		</>
	);
};
